import React from "react";
import SportsmenImage from "./Components/SportsmenImageNba.jsx";
import Flag from "./Components/Flag.jsx";

const MatchSideImageOrFlag = ({ side, small, displaySquareBorder }) => {
  return (
    <span
      className={`match-side-img-flag ${
        !displaySquareBorder ? "no-border" : ""
      }`}
    >
      {side.imageSrc ? (
        <SportsmenImage small={small} {...side} />
      ) : (
        <Flag code={side.countryCode} />
      )}
    </span>
  );
};

export default MatchSideImageOrFlag;
